import React from 'react';
import { Link } from 'react-router-dom';

import { milestones } from '../data/mockData';
import { getTagColor, getProgressColor } from '../utils/tagmeHelpers';

const MilestoneGrid = ({ onMilestoneClick }) => {
  return (
    <div className='flex-1'>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4'>
        {milestones.map(milestone => (
          <div
            key={milestone.id}
            className='bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md hover:scale-105 transition-all duration-300'
          >
            {/* Milestone Image */}
            <div className='relative'>
              <div
                onClick={() => onMilestoneClick && onMilestoneClick(milestone)}
                className='block cursor-pointer'
              >
                <img
                  src={milestone.image}
                  alt={milestone.title}
                  className='w-full aspect-square object-cover'
                />
              </div>
            </div>

            {/* Milestone Content */}
            <div className='p-3'>
              <div
                onClick={() => onMilestoneClick && onMilestoneClick(milestone)}
                className='block cursor-pointer'
              >
                <h3 className='font-bold text-gray-900 mb-1 text-sm hover:text-purple-600 transition-colors duration-200'>
                  {milestone.title}
                </h3>
                <p className='text-xs text-gray-600 mb-2'>
                  {milestone.description}
                </p>
              </div>

              {/* Progress Bar */}
              <div className='mb-2'>
                <div className='flex items-center justify-between mb-1'>
                  <span className='text-xs text-gray-700'>Progress</span>
                  <span className='text-xs font-medium text-gray-900'>
                    {milestone.progress}%
                  </span>
                </div>
                <div className='w-full bg-gray-200 rounded-full h-1'>
                  <div
                    className={`h-1 rounded-full transition-all duration-300 ${getProgressColor(
                      milestone.tags[0]
                    )}`}
                    style={{ width: `${milestone.progress}%` }}
                  ></div>
                </div>
              </div>

              {/* Team Members and Timestamp */}
              <div className='flex items-center justify-between'>
                <div className='flex items-center'>
                  <div className='flex -space-x-1 mr-2'>
                    {milestone.teamMembers.slice(0, 3).map((member, index) => (
                      <img
                        key={index}
                        src={member.avatar}
                        alt={member.name}
                        className='w-5 h-5 rounded-full border border-white'
                      />
                    ))}
                  </div>
                  <span className='text-xs text-gray-600'>
                    {milestone.teamMembers.length} members
                  </span>
                </div>
                <span className='text-xs text-gray-500'>
                  {milestone.timestamp}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MilestoneGrid;
